import { WidgetClosingTrigger } from '@wix/wix-chatbot-common/bi';

import { getRuntimeDataForBi } from '../../../bi/utils/getRuntimeDataForBi';
import { TRootState } from '../../../common/reducers';
import { experiments } from '../../../experiments';
import { widgetSDK } from '../../../sdk/widgetSDK';

export enum CaraSessionReferral {
  HW_ANNOUNCEMENT_BANNER = 1, // 'hw_announcement_banner'
  HW_HOMEPAGE_CTA = 2, // 'hw_homepage_cta'
  HC_ARTICLE_PAGE = 3, // 'hc_article_page'
  CHATBOT_EDITOR_INTENT_EP = 4, // 'chatbot_editor_intent_ep'
}

export const CARA_RETURN_REFERRAL = 'cara';

const CARA_BASE_URL = 'https://manage.wix.com/cc-live-assistant';

const buildCaraUrl = async (
  state: TRootState,
  session_referral: CaraSessionReferral,
  conversationId?: string,
): Promise<string> => {
  const url = new URL(CARA_BASE_URL);
  const { metaSiteId, sessionId, contextBi } = await getRuntimeDataForBi(state);

  const params: Record<string, string | number | undefined> = {
    session_referral: String(session_referral),
    context_msid: metaSiteId,
    self_service_session_id: sessionId,
    context_platform: contextBi?.context_platform,
    conversation_id: conversationId?.trim() || undefined,
  };

  Object.entries(params).forEach(([key, value]) => {
    if (value !== undefined && value !== null && value !== '') {
      url.searchParams.append(key, String(value));
    }
  });

  return url.toString();
};

const CARA_POPUP_WIDTH = 360;
const CARA_POPUP_HEIGHT = 536;

let caraPopupRef: Window | null = null;

const getPopupPosition = (event: MouseEvent) => ({
  left: event.screenX - event.clientX,
  top: event.screenY - event.clientY,
});

const openCaraPopup = (url: string, left: number, top: number) => {
  if (caraPopupRef && !caraPopupRef.closed) {
    caraPopupRef.focus();
    return;
  }

  const popup = window.open(
    url,
    'cara-popup',
    `width=${CARA_POPUP_WIDTH},height=${CARA_POPUP_HEIGHT},left=${left},top=${top}`,
  );

  if (popup) {
    caraPopupRef = popup;
    widgetSDK.collapseWidget(WidgetClosingTrigger.CloseButton);
  }
};

export const openCara = async (
  state: TRootState,
  session_referral: CaraSessionReferral,
  event: MouseEvent,
  conversationId?: string,
): Promise<string> => {
  const { left, top } = getPopupPosition(event);
  const url = await buildCaraUrl(state, session_referral, conversationId);

  if (experiments.is('specs.LeanPopupVoiceFirstUX', 'true')) {
    openCaraPopup(url, left, top);
  } else {
    window.open(url, '_blank');
  }

  return url;
};
